import React, { forwardRef, useRef, useState, useEffect } from 'react';
import { CFormInput } from "@coreui/react";
import clsx from "classnames";
import style from "./InputText.module.css";

const MessageInput = forwardRef((props, ref) => {
  const {
    value: externalValue,
    onChange,
    placeHolder,
    label,
    style: extraStyle = {},
    disabled,
    readOnly,
    lineText,
  } = props;

  const inputRef = useRef(null);
  const [internalValue, setInternalValue] = useState(externalValue || '');
  const [active, setActive] = useState(!!externalValue);

  // 외부 값 변경 시 동기화
  useEffect(() => {
    if (externalValue !== undefined) {
      setInternalValue(externalValue);
      setActive(!!externalValue);
    }
  }, [externalValue]);

  // 스크롤 이벤트 핸들러
  useEffect(() => {
    const handleScroll = () => {
      if (document.activeElement === inputRef.current) {
        inputRef.current.blur(); // 즉시 포커스 해제
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    setActive(!!newValue);
  };

  const handleBlur = () => {
    if (onChange && internalValue !== externalValue) {
      onChange(internalValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      inputRef.current?.blur();
    }
  };

  const inputStyle = {
    border: "none",
    boxShadow: "none",
    borderRadius: "0",
    fontSize: "15px",
    padding: "0 20px",
    color: "var(--font-color)",
    height: "50px",
  };

  const defaultInputStyle = {
    "--cui-invalid-feedback": "none",
    boxShadow: "none",
    borderRadius: "0",
    fontSize: "15px",
    border: "1px solid var(--line-color)",
  };

  const baseProps = {
    style: lineText ? { ...inputStyle, ...extraStyle } : { ...defaultInputStyle, ...extraStyle },
    value: internalValue,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    placeholder: placeHolder,
    label: label,
    ref: inputRef,
    disabled: disabled,
    readOnly: readOnly,
  };

  if (lineText) {
    return (
      <div className={clsx(style.wrap, {
        [style.active]: active,
      })}>
        <CFormInput {...baseProps} />
        <p className={clsx(
          style.placeHolder,
          { [style.readOnly]: readOnly },
          { [style.active]: active },
          { [style.defaultPlaceHolder]: !active }
        )}>
          {placeHolder}
        </p>
      </div>
    );
  }

  return (
    <div className={style.wrap}>
      <CFormInput {...baseProps} />
    </div>
  );
});

MessageInput.displayName = 'MessageInput';
export default MessageInput;